/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateUpdateDeliverFeeKrGradeAmountReqVo
 */
export interface CreateUpdateDeliverFeeKrGradeAmountReqVo {
    /**
     * 用户等级编号
     * @type {number}
     * @memberof CreateUpdateDeliverFeeKrGradeAmountReqVo
     */
    gradeId: number;
    /**
     * 金额
     * @type {number}
     * @memberof CreateUpdateDeliverFeeKrGradeAmountReqVo
     */
    amount: number;
}

/**
 * Check if a given object implements the CreateUpdateDeliverFeeKrGradeAmountReqVo interface.
 */
export function instanceOfCreateUpdateDeliverFeeKrGradeAmountReqVo(value: object): value is CreateUpdateDeliverFeeKrGradeAmountReqVo {
    if (!('gradeId' in value) || value['gradeId'] === undefined) return false;
    if (!('amount' in value) || value['amount'] === undefined) return false;
    return true;
}

export function CreateUpdateDeliverFeeKrGradeAmountReqVoFromJSON(json: any): CreateUpdateDeliverFeeKrGradeAmountReqVo {
    return CreateUpdateDeliverFeeKrGradeAmountReqVoFromJSONTyped(json, false);
}

export function CreateUpdateDeliverFeeKrGradeAmountReqVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateUpdateDeliverFeeKrGradeAmountReqVo {
    if (json == null) {
        return json;
    }
    return {
        
        'gradeId': json['gradeId'],
        'amount': json['amount'],
    };
}

export function CreateUpdateDeliverFeeKrGradeAmountReqVoToJSON(json: any): CreateUpdateDeliverFeeKrGradeAmountReqVo {
    return CreateUpdateDeliverFeeKrGradeAmountReqVoToJSONTyped(json, false);
}

export function CreateUpdateDeliverFeeKrGradeAmountReqVoToJSONTyped(value?: CreateUpdateDeliverFeeKrGradeAmountReqVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'gradeId': value['gradeId'],
        'amount': value['amount'],
    };
}

